/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
export default {
  "sitecoreApiKey": "{FF6BD2B5-14C5-48A4-AFB9-69F2540EABD0}",
  "sitecoreApiHost": "",
  "jssAppName": "Spa",
  "defaultLanguage": "de-de",
  "graphQLEndpointPath": "/api/jss/app",
  "graphQLEndpoint": "/api/jss/app"
};